import { Box } from "@mui/material";
import { HeaderField } from "@/pages/reports/summary-by-close-date/components/AccountSummaryHeader";
import {
	DATE_RANGE_HEADER_HELP,
	type DateRangeSummaryRow,
	toSheetDate,
} from "../models/SummaryByDateRange";

interface Props {
	summary: DateRangeSummaryRow;
}

export const DateRangeSummaryHeader = ({ summary }: Props) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "baseline",
			flexWrap: "wrap",
			columnGap: 4,
			rowGap: 0.5,
			px: 2,
			pt: 1.5,
			pb: 1.25,
		}}
	>
		<HeaderField
			label="Start Date:"
			value={toSheetDate(summary.StartDate)}
			help={DATE_RANGE_HEADER_HELP.start}
		/>
		<HeaderField
			label="Close Date:"
			value={toSheetDate(summary.CloseDate)}
			help={DATE_RANGE_HEADER_HELP.close}
		/>
		<Box sx={{ flexGrow: 1, minWidth: 8 }} />
		<HeaderField
			label="G/L Account Number:"
			value={summary.CostCenterName ?? ""}
		/>
		<HeaderField
			label="# Registers Found:"
			value={String(summary.NumRegsFound ?? "")}
			help={DATE_RANGE_HEADER_HELP.registers}
		/>
	</Box>
);
